import { render } from "./B2CReferences.vue?vue&type=template&id=0e196658&lang=pug"
import script from "./B2CReferences.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CReferences.vue?vue&type=script&setup=true&lang=js"

import "./B2CReferences.vue?vue&type=style&index=0&id=0e196658&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__